export function isUserRejectedError(e: unknown): boolean {
  return (e as Error)?.message?.toLowerCase().includes('user rejected');
}
